// extracted by mini-css-extract-plugin
export default {"zbList":"index_zbList_u5F64","box300":"index_box300_85OUw"};